import AddIcon from '@mui/icons-material/Add';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useDocumentBankTags, useCompanies } from '../../../hooks';

// Diger ayarlar sayfalari (TagsPage vb.) ile ayni pattern: DynamicCrudPage
// entityType + hook baglar; TABLE_COLUMNS / FORM_CONFIGS / FILTER_CONFIGS /
// SEARCH_CONFIGS.documentBankTags icinde tanimli.
const DocumentBankTagsPage = () => (
  <DynamicCrudPage
    entityType="documentBankTags"
    hook={useDocumentBankTags}
    additionalHooks={{ companies: useCompanies }}
    addButtonTextKey="documentBankTags.addButton"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="documentBankTag"
  />
);

export default DocumentBankTagsPage;
